import React, {useState} from "react";
// import { Link } from 'react-router-dom'
import {Modal, NavDropdown} from "react-bootstrap";
import {useDispatch, useSelector} from "react-redux";
import {toast} from "react-toastify";
import {LogoutUser, unlockUser} from "../../redux/actions/Auth.Action";
import ApiConnect from "../../Utils/ApiConnect";
import {safeLocalStorage} from "../../Utils/storage";

const UserinfoDropdown = () => {
  const state = useSelector((state) => state.Auth.userData);
  const dispatch = useDispatch();
  const [showModal, setShowmodal] = useState(false);
  const [formError, setFormError] = useState(false);
  const [newpasswd, setNewpasswd] = useState([]);
  const [show, setShow] = useState(false);

  const handlePasswordChange = (e) => {
    const newData = { ...newpasswd };
    newData[e.target.name] = e.target.value;
    setNewpasswd(newData);
    if (newData.new !== newData.verify) {
      setFormError(`New Password Didn't Match`);
    } else {
      setFormError(false);
    }
  };
  const submitHandler = (e) => {
    e.preventDefault();
    let formData = new FormData();
    formData.append("new", newpasswd.new);
    formData.append("verify", newpasswd.verify);
    ApiConnect({
      method: "post",
      url: "/Module/Utilities/Users/ChangePassword",
      data: formData,
    })
      .then((response) => {
        if (response.data.status === 200) {
          toast.success(response.data.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            draggableDirection: "y",
          });
          setShowmodal(false);
          setNewpasswd([]);
        } else {
          toast.error(response.data.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            draggableDirection: "y",
          });
        }
      })
      .catch((error) => console.log(error));
  };
  return (
    <>
      <NavDropdown
        className="dropdown"
        title={
          <img
            className="avatar"
            src={state ? state.userimage : ""}
            alt={state ? state.username : ""}
          />
        }
      >
        {/* <Link className="dropdown-item d-flex align-items-center" to=""><span className="material-icons-outlined">manage_accounts</span> Profile</Link>
      <Link className="dropdown-item d-flex align-items-center" to=""><span className="material-icons-outlined">tune</span> Settings</Link> */}
        <span
          className="dropdown-item d-flex align-items-center"
          onClick={() => dispatch(unlockUser())}
        >
          <span className="material-icons-outlined">lock</span> Lock Screen
        </span>
        <div className="dropdown-divider" />
        <span
          className="dropdown-item d-flex align-items-center"
          onClick={() => setShowmodal(true)}
        >
          <span className="material-icons-outlined">password</span> Change
          Password
        </span>
        <span
          className="dropdown-item d-flex align-items-center"
          onClick={() => {
            dispatch(LogoutUser());
            safeLocalStorage.removeItem("AutoLogin");
          }}
        >
          <span className="material-icons-outlined">logout</span> Logout
        </span>
      </NavDropdown>
      <Modal
        show={showModal}
        className="modal-center"
        onHide={() => setShowmodal(false)}
      >
        <Modal.Dialog>
          <Modal.Header>
            <h5 className="modal-title">Change Password</h5>
            <button
              type="button"
              className="btn"
              onClick={() => setShowmodal(false)}
            >
              <span>×</span>
            </button>
          </Modal.Header>
          <form onSubmit={(e) => submitHandler(e)}>
            <Modal.Body>
              <p className="text-danger">{formError}</p>
              <label className="form-label">New Password</label>
              <label className="col-12">
                <div className="input-group">
                  <input
                    type={show ? "text" : "password"}
                    className="form-control"
                    name="new"
                    required="required"
                    onChange={(e) => {
                      handlePasswordChange(e);
                    }}
                  />
                  <div className="input-group-append">
                    <span className="input-group-text">
                      <span className="material-icons-outlined">
                        visibility_off
                      </span>
                    </span>
                  </div>
                </div>
              </label>
              <label className="form-label">Verify Password</label>
              <label className="col-12">
                <div className="input-group">
                  <input
                    type={show ? "text" : "password"}
                    className="form-control"
                    name="verify"
                    required="required"
                    onChange={(e) => {
                      handlePasswordChange(e);
                    }}
                  />
                  <div className="input-group-append">
                    <span
                      className="input-group-text"
                      onClick={() => setShow(!show)}
                    >
                      <span className="material-icons-outlined">
                        visibility_off
                      </span>
                    </span>
                  </div>
                </div>
              </label>
            </Modal.Body>
            <Modal.Footer>
              <button type="submit" className="btn btn-success">
                Change
              </button>
            </Modal.Footer>
          </form>
        </Modal.Dialog>
      </Modal>
    </>
  );
};
export default React.memo(UserinfoDropdown);
